import React, { Component } from "react";
import { translate } from "react-i18next";
import { Panel } from 'react-bootstrap';

class HLAForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
        // id: 0,
        // allelo: "",
        // results: {}
    };
  }

  componentDidMount() {
  }

  render() {
    return (
        <div className="col-xs-12 col-sm-6" >
            <Panel className="card">
                <Panel.Body style={{ padding: "1em 0 0" }}>
                    <div
                        style={{
                        marginBottom: "0.5em",
                        padding: "0 0.5em",
                        fontSize: "1em",
                        }}
                    >
                        Nombre del Alelo:
                        <span className="text-danger ml-2" style={{ marginLeft: "0.5em" }}>
                            {this.props.state.allelo}
                        </span>
                    </div>
                    <div className="col-sm-6" style={{ padding: "0 0.5em" }}>
                        <div className="form-group">
                        <label>Resultados Padre</label>
                        <input
                            type="text"
                            name="father"
                            className="form-control"
                            style={{ fontSize: "1em" }}
                            value={this.props.state.results.father}
                            onChange={(e)=>this.props.changeAllels('father', e.target.value, this.props.index)}
                        />
                        </div>
                        <div className="form-group">
                        <label>Pares completos</label>
                        <textarea
                            name="fatherComplete"
                            className="form-control"
                            style={{ resize: "none", fontSize: "1em" }}
                            rows="5"
                            value={this.props.state.results.father_complete}
                            onChange={(e)=>this.props.changeAllels('father_complete', e.target.value, this.props.index)}
                        ></textarea>
                        </div>
                    </div>
                    <div className="col-sm-6" style={{ padding: "0 0.5em" }}>
                        <div className="form-group">
                        <label>Resultados Madre</label>
                        <input
                            type="text"
                            name="mother"
                            className="form-control"
                            style={{ fontSize: "1em" }}
                            value={this.props.state.results.mother}
                            onChange={(e)=>this.props.changeAllels('mother', e.target.value, this.props.index)}
                        />
                        </div>
                        <div className="form-group">
                        <label>Pares completos</label>
                        <textarea
                            name="motherComplete"
                            className="form-control"
                            style={{ resize: "none", fontSize: "1em" }}
                            rows="5"
                            value={this.props.state.results.mother_complete}
                            onChange={(e)=>this.props.changeAllels('mother_complete', e.target.value, this.props.index)}
                        ></textarea>
                        </div>
                    </div>
                </Panel.Body>
            </Panel>
        </div>
    );
  }
}

export default translate('translations') (HLAForm);